import { parseOAuthCallbackUrl, shouldResolveRegistrationToken } from './OAuthCallbackUrl.mjs';
const HANDLED_FLAG = '__devconnectOauthCallbackHandled';

/**
 * Завершает единый callback Яндекс ID и VK ID, не дублируя протокольную логику в расширениях провайдеров.
 */
export function handleOAuthCallback(app, sessionExpiredMessage, linkedMessage) {
  // Оба расширения подключают общий обработчик, поэтому флаг гарантирует ровно один запуск на страницу.
  if (window[HANDLED_FLAG]) {
    return false;
  }
  const callback = parseOAuthCallbackUrl(window.location.href);

  // На обычной странице обработчик ничего не меняет и не создаёт лишних запросов к API.
  if (callback === null) {
    return false;
  }
  window[HANDLED_FLAG] = true;

  // Popup передаёт исходный callback вместе с маркером: основное окно должно распознать и завершить вход.
  if (window.opener && !window.opener.closed) {
    window.opener.location.assign(callback.callbackUrl);
    window.close();
    return true;
  }

  // Чувствительные параметры удаляются синхронно, до сетевого запроса и открытия модального окна.
  window.history.replaceState({}, '', callback.cleanUrl);

  // Отказ провайдера выводится штатным уведомлением Flarum без создания регистрационной сессии.
  if (callback.error) {
    app.alerts.show({
      type: 'error'
    }, callback.error);
    return true;
  }

  // Привязка завершена в существующей сессии и не требует регистрационного токена.
  if (callback.linkedProvider) {
    app.alerts.show({
      type: 'success'
    }, linkedMessage);
    return true;
  }

  // Успешно авторизованный пользователь не должен обрабатывать оставшийся в старой вкладке регистрационный токен.
  if (!shouldResolveRegistrationToken(callback, Boolean(app.session.user))) {
    return true;
  }

  // Сервер раскрывает только безопасные поля короткоживущего токена для штатной формы завершения регистрации.
  app.request({
    url: `${app.forum.attribute('apiUrl')}/registration-token`,
    method: 'POST',
    body: {
      token: callback.registrationToken
    },
    // Ошибка обрабатывается ниже один раз; штатный обработчик Flarum иначе покажет второе уведомление для того же 404.
    errorHandler: () => {}
  }).then(registration => {
    // Штатный SignUpModal сохраняет проверки Flarum и передаёт OAuth-токен только в POST /register.
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'), {
      token: callback.registrationToken,
      username: registration.username || '',
      email: registration.email || '',
      provided: Array.isArray(registration.provided) ? registration.provided : []
    });
  }).catch(() => {
    // Для действительно истёкшей гостевой сессии выводится одно понятное уведомление вместо двух технических ошибок.
    app.alerts.show({
      type: 'error'
    }, sessionExpiredMessage);
  });
  return true;
}
flarum.reg.add('devconnect-oauth-yandex', '../../../devconnect-oauth-core/js/src/forum/service/OAuthCallbackHandler', { handleOAuthCallback: handleOAuthCallback, });